import styled from "styled-components";
import { Accordion, AccordionDetails, AccordionSummary, IconButton } from "@mui/material";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 25px;
	background: ${({ theme }) => theme.grayLight};
	padding: 15px;
	margin-bottom: 20px;
`;

export const AccordionSupplier = styled(Accordion)`
	&&& {
		background: ${({ theme }) => theme.grayLight};
		padding: 0.6rem 0;
		margin: 0 0 1rem;

		/* When is Expanded */
		&.MuiAccordion-root.Mui-expanded {
			margin: 0 0 1rem;
		}

		.MuiAccordionSummary-content {
			width: 100%;
		}

		.MuiSvgIcon-root {
			color: ${({ theme }) => theme.pantone2727C};
		}
	}
`;
export const AccordionTitle = styled.h5`
	font-weight: bold;
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
	margin-bottom: 8px;
	min-height: 32px;
`;
export const AccordionSummarySupplier = styled(AccordionSummary)`
	&&& {
		background: ${({ theme }) => theme.grayLight};
	}
`;
export const AccordionDetailsSupplier = styled(AccordionDetails)`
	&&& {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		background: ${({ theme }) => theme.grayLight};
	}
`;

export const Invoice = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	background: ${({ theme }) => theme.white};
	box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.2);
	padding: 0.8rem 0.4rem;
	width: 100%;

	> p {
		margin: 0 0 0 0.4rem;
	}
`;

export const ButtonDownloadFile = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.pantone2727C};
		margin: 0 0 0 auto;
	}
`;

export const BoxInput = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const ContainerButton = styled.div`
	display: flex;
	gap: 10px;
	justify-content: center;

	button {
		padding: 5px 15px;
		min-width: 100px;
		background: transparent;
	}

	@media (max-width: 768px) {
		flex-direction: column-reverse;

		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;
